<mat-chip-listbox *ngIf="workflowStatsDto && workflowStatsDto.workflowStatDtoList">
  <mat-chip-option removable="false" selected *ngFor="let stat of workflowStatsDto.workflowStatDtoList"
    color="{{stat.colour}}">
    {{ stat.state }} - {{ stat.numStates }}
  </mat-chip-option>
</mat-chip-listbox>